/* eslint-disable */
import listing from "@/apollo/packages/hotels/listing.gql";
import hotel_by_id from "@/apollo/packages/hotels/hotel_by_id.gql";
import create_update from "@/apollo/packages/hotels/create_update.gql";

export const state = () => ({
  listing: [],
  is_loading: false
});

export const mutations = {
  /**
   * @description
   * @author Saurabh Jangra
   * @date 30 Apr 2024 | 04:45PM
   * @param {*} state
   * @param {*} value
   */
  setListing(state, value) {
    state.listing = value;
  },
  /**
   * @description
   * @author Saurabh Jangra
   * @date 30 Apr 2024 | 04:45PM
   * @param {*} state
   * @param {*} value
   */
  setLoading(state, value) {
    state.is_loading = value;
  }
};

export const actions = {
  /**
   * @description
   * @author Saurabh Jangra
   * @date 30 Apr 2024 | 04:45PM
   * @param {*} { commit }
   * @returns {*}
   */
  fetchListing({ commit }, search_by) {
    commit("setListing", []);
    commit("setLoading", true);
    return new Promise((resolve) => {
      this.$apolloClient
        .query({ query: listing, variables: { search_by } })
        .then(({ data }) => {
          commit("setListing", data.pkgHotels);
          resolve(data.pkgHotels);
          commit("setLoading", false);
        })
        .catch(() => {
          commit("setLoading", false);
        });
    });
  },
  /**
   * @description
   * @author Saurabh Jangra
   * @date 01 May 2024 | 04:28PM
   * @param {*} __
   * @param {*} hotel_id
   * @returns {*}
   */
  fetchHotelById(__, hotel_id) {
    return new Promise((resolve) => {
      this.$apolloClient.query({ query: hotel_by_id, variables: { hotel_id } }).then(({ data }) => {
        resolve(data.pkgHotelById);
      });
    });
  },
  /**
   * @description
   * @author Saurabh Jangra
   * @date 02 May 2024 | 12:19PM
   * @param {*} __
   * @param {*} payload
   * @returns {*}
   */
  create(__, payload) {
    return new Promise((resolve) => {
      this.$apolloClient.mutate({ mutation: create_update, variables: { payload } }).then(({ data }) => {
        resolve(data.pkgHotelCreate);
      });
    });
  }
};

export const getters = {
  listing: (state) => state.listing,
  is_loading: (state) => state.is_loading
};
